/**
 * ProductImagesSection – product images using the canonical MediaImageManager.
 *
 * Supports two modes:
 * 1. Edit mode: productId is provided → uploads directly to public-media
 * 2. Draft mode: draftSessionId is provided → uploads to private-media (finalized on save)
 */

import { MediaImageManager } from '@/components/media/MediaImageManager';
import { useMediaUpload } from '@/hooks/useMediaUpload';

interface ProductImagesSectionProps {
  producerId: string;
  /** Set for existing products (edit mode). */
  productId?: string;
  /** Set for new products before DB row exists (create mode). */
  draftSessionId?: string;
}

export function ProductImagesSection({
  producerId,
  productId,
  draftSessionId,
}: ProductImagesSectionProps) {
  const isDraft = !productId;

  const coverUpload = useMediaUpload({
    ownerType: 'product',
    ownerId: isDraft ? null : productId,
    draftSessionId: isDraft ? draftSessionId : undefined,
    kind: 'cover',
    maxFiles: 1,
  });

  const galleryUpload = useMediaUpload({
    ownerType: 'product',
    ownerId: isDraft ? null : productId,
    draftSessionId: isDraft ? draftSessionId : undefined,
    kind: 'gallery',
    maxFiles: 10,
  });

  return (
    <MediaImageManager
      ownerType="product"
      ownerId={productId ?? null}
      producerId={producerId}
      draftSessionId={draftSessionId ?? ''}
      coverUpload={coverUpload}
      galleryUpload={galleryUpload}
      helperText="Ladda upp produktbilder. Första bilden blir omslagsbild."
    />
  );
}
